import React from 'react'
import "../styles/index.scss"
import UsersPage from "./UsersPage"

function UsersContainers() {
    return (
        <div className='UsersContainers'>
            <UsersPage/>
        </div>
    )
}

export default UsersContainers
